import Icons from "../components/admin/dashboard/svgIcons";
import {
  BriefcaseIcon,
  AdjustmentsVerticalIcon,
  HomeIcon,
  DocumentTextIcon,
  AcademicCapIcon,
  QuestionMarkCircleIcon,
  ArrowLeftOnRectangleIcon,
  UserIcon,
} from "@heroicons/react/24/outline";

export const navigation = [
  {
    name: "Dashboard",
    href: "/admin-dashboard",
    icon: HomeIcon,
    current: true,
    children: [
      { name: "Admin/Owner Data", href: "/admin-dashboard" },
      { name: "Professional Data", href: "/admin-dashboard/professional-data" },
      // { name: "Leads/Match Data", href: "/admin-dashboard/match-data" },
    ],
  },
  {
    name: "Users",
    href: "/admin-dashboard/users",
    icon: UserIcon,
    current: false,
    children: [
      { name: "Professionals", href: "/admin-dashboard/users" },
      // { name: "Leads", href: "/admin-dashboard/users/leads" },
    ],
  },
  {
    name: "Matches",
    href: "/admin-dashboard/matches",
    icon: BriefcaseIcon,
    current: false,
    children: [
      { name: "Successful Matches", href: "/admin-dashboard/matches" },
      { name: "Pending Matches", href: "/admin-dashboard/pending" },
      { name: "Failed Matches", href: "/admin-dashboard/unmatched" },
    ],
  },
  {
    name: "Credit Requests",
    href: "/admin-dashboard/credit-requests",
    icon: Icons.CreditRequestSvg,
    current: false,
    badge: true,
  },
  {
    name: "Invoices",
    href: "/admin-dashboard/invoices",
    icon: DocumentTextIcon,
    current: false,
  },
  {
    name: "Admin Tools",
    href: "/admin-dashboard/admin-tools",
    icon: Icons.AdminToolsSvg,
    current: false,
    children: [
      { name: "Professions", href: "/admin-dashboard/admin-tools" },
      {
        name: "Email Templates",
        href: "/admin-dashboard/admin-tools/email-templates",
      },
      {
        name: "Global Alerts",
        href: "/admin-dashboard/admin-tools/global-alerts",
      },
      {
        name: "nova",
        href: "/admin-dashboard/admin-tools/global-alerts",
      },
      {
        name: "Lead Cap",
        href: "/admin-dashboard/admin-tools/admin/dashboard",
      },
    ],
  },
  {
    name: "Education Center",
    href: "/admin-dashboard/education-center",
    icon: AcademicCapIcon,
    current: false,
  },
  {
    name: "Support",
    href: "/admin-dashboard/support",
    icon: QuestionMarkCircleIcon,
    current: false,
    children: [
      {
        name: "Professional Inquiries",
        href: "/admin-dashboard/support",
      },
      {
        name: "Lead Inquiries",
        href: "/admin-dashboard/support/lead-inquiries",
      },
    ],
  },
];

export const footerNavigation = [
  {
    name: "Settings",
    href: "/admin-dashboard/settings",
    icon: AdjustmentsVerticalIcon,
    current: false,
  },
  {
    name: "Sign Out",
    icon: ArrowLeftOnRectangleIcon,
    current: false,
  },
];

export const userNavigation = [
  { name: "Your Profile", href: "/admin-dashboard/settings" },
  { name: "Sign Out" },
];
